import { Component, OnInit, inject, DestroyRef } from '@angular/core';
import { Constants } from 'src/app/models/constants';
import { HttpClient } from '@angular/common/http';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {

  year: string;

  Constants = Constants;
  version: string;
  private destroyRef = inject(DestroyRef);

  constructor(private http: HttpClient) {  }

  ngOnInit(): void {
    this.year = new Date().getFullYear().toString();

    const url = '';

    this.http.get(url, { responseType: 'text' })
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(data => {
      const latestVersion = data.split('\n');
      if (latestVersion) {
        this.version = latestVersion[2].split(' ')[1];
      }
    });



  }

}
